import React from "react";

interface ReceiptCategoryFilterProps {
  value?: string | number | null;
  onChange?: (value: string) => void;
}

export const ReceiptCategoryFilter: React.FC<ReceiptCategoryFilterProps> = ({
  value,
  onChange,
}) => {
  return (
    <select
      className="border px-2 py-1 rounded text-sm text-gray-700"
      value={value ?? ""}
      onChange={(e) => onChange?.(e.target.value)}
    >
      <option value="">Tất cả loại phiếu</option>
      <option value="1">Phiếu Thu</option>
      <option value="2">Phiếu Chi</option>
    </select>
  );
};
